/* global Config */

// Vendor Components
import React from 'react';
import {Link} from 'react-router-dom';

// Components
import MainNav from './main-nav';
import Permissions from '../../core/permissions';
import LoggedInDropdown from '../../app/logged-in-dropdown';
import packageJson from '../../../../package.json';

// Logos
import Logo from '../../../images/metacloud-logo.svg';
import LogoAdult from '../../../images/metacloud-logo-adult.svg';

// Styles
import './main-header.scss';

function MainHeader() {
    return (
        <header className="main-header">
            <Link className="main-header--link" to="/">
                <img
                    alt=""
                    className="main-header--logo"
                    src={Config.base.matureContent ? LogoAdult : Logo}
                    title={`MetaCloud - ${packageJson.version}`}
                />
            </Link>
            <LoggedInDropdown className="main-header--logged-in" />
            <Permissions>
                <MainNav className="main-header--main-nav" />
            </Permissions>
        </header>
    );
}

export default MainHeader;
